var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import * as moment from 'moment';
import { DATETIME_FORMAT } from '../../../shared/utils/timeUtils';
import { Store } from '@ngrx/store';
import { getProjectsReportSelector, getReportFiltersSelector } from '../reports.reducer';
import { SetReportFiltersAction } from '../reports.actions';
import { URLSearchParams } from '@angular/http';
import { ConfigService } from '../../../config/config.service';
import { CrazyCallConfigService } from '../../shared/services/crazycall-config.service';
var ReportFiltersComponent = /** @class */ (function () {
    function ReportFiltersComponent(fb, store, crazyCallConfigService, configService) {
        this.fb = fb;
        this.store = store;
        this.crazyCallConfigService = crazyCallConfigService;
        this.configService = configService;
        this.isExpanded = true;
        this.liveModeEnabled = false;
        this.backendUrl = this.configService.backendUrl;
    }
    ReportFiltersComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.createEmptySearchForm();
        this.store.select(getProjectsReportSelector).subscribe(function (projects) {
            _this.projects = projects.sort(function (a, b) { return a.name.localeCompare(b.name); });
        });
        this.store.select(getReportFiltersSelector).subscribe(function (filter) {
            if (!filter) {
                return;
            }
            var projects = (filter && filter.projects) || _this.projects.map(function (_a) {
                var id = _a.id;
                return id;
            });
            _this.reportsForm.controls['projects'].setValue(projects);
            _this.reportsForm.controls['dateRange'].setValue(filter.dateRange);
            _this.liveModeEnabled = filter.liveModeEnabled;
            if (filter.liveModeEnabled) {
                _this.datePickerEndDate = filter.dateRange.dateTo;
            }
        });
        if (this.liveModeEnabled) {
            this.setCurrentTimeAsDateTo();
        }
        this.dispatchFiltersToTheStore();
    };
    Object.defineProperty(ReportFiltersComponent.prototype, "dateFrom", {
        get: function () {
            return moment(this.reportsForm.controls.dateRange.value.dateFrom).format(DATETIME_FORMAT);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportFiltersComponent.prototype, "dateTo", {
        get: function () {
            return moment(this.reportsForm.controls.dateRange.value.dateTo).format(DATETIME_FORMAT);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportFiltersComponent.prototype, "dateRange", {
        get: function () {
            var _a = this.reportsForm.controls.dateRange.value, dateFrom = _a.dateFrom, dateTo = _a.dateTo;
            return { dateFrom: dateFrom, dateTo: dateTo };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportFiltersComponent.prototype, "projectsAreSelected", {
        get: function () {
            return this.reportsForm.controls.projects.value && this.reportsForm.controls.projects.value.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportFiltersComponent.prototype, "selectedProjects", {
        get: function () {
            var selectedProjects = this.reportsForm.controls.projects.value;
            return this.projects
                .filter(function (project) { return selectedProjects.includes(project.id); })
                .map(function (project) { return project.name; })
                .join(', ');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ReportFiltersComponent.prototype, "reportUrl", {
        get: function () {
            var filters = this.reportFilters;
            var params = new URLSearchParams();
            params.set('projectIds', filters.projects.toString());
            params.set('dateFrom', filters.dateRange.dateFrom.toISOString());
            params.set('dateTo', filters.dateRange.dateTo.toISOString());
            params.set('account', this.crazyCallConfigService.appId);
            params.set('utcOffsetInMinutes', moment()
                .utcOffset()
                .toString());
            return this.backendUrl + "/lead-generation/reports?" + params.toString();
        },
        enumerable: true,
        configurable: true
    });
    ReportFiltersComponent.prototype.selectAllProjects = function () {
        var projectIds = this.projects.map(function (project) { return project.id; });
        this.reportsForm.controls['projects'].setValue(projectIds);
    };
    ReportFiltersComponent.prototype.unselectAllProjects = function () {
        this.reportsForm.controls['projects'].setValue([]);
    };
    ReportFiltersComponent.prototype.createEmptySearchForm = function () {
        this.reportsForm = this.fb.group({
            dateRange: {
                dateFrom: moment()
                    .startOf('day')
                    .toDate(),
                dateTo: moment()
                    .endOf('day')
                    .toDate()
            },
            projects: []
        });
    };
    ReportFiltersComponent.prototype.changeDateRange = function (_a) {
        var dateFrom = _a.dateFrom, dateTo = _a.dateTo;
        var dateRange = {
            dateFrom: moment(dateFrom).toDate(),
            dateTo: moment(dateTo).toDate()
        };
        this.reportsForm.controls['dateRange'].setValue(dateRange);
    };
    ReportFiltersComponent.prototype.setCurrentTimeAsDateTo = function () {
        var dateRange = __assign({}, this.dateRange, { dateTo: moment().toDate() });
        this.reportsForm.controls['dateRange'].setValue(dateRange);
    };
    ReportFiltersComponent.prototype.onSubmit = function () {
        this.dispatchFiltersToTheStore();
    };
    ReportFiltersComponent.prototype.changeExpandedState = function () {
        this.isExpanded = !this.isExpanded;
    };
    ReportFiltersComponent.prototype.dispatchFiltersToTheStore = function () {
        this.store.dispatch(new SetReportFiltersAction(this.reportFilters));
    };
    Object.defineProperty(ReportFiltersComponent.prototype, "reportFilters", {
        get: function () {
            var reportFilters = this.reportsForm.getRawValue();
            reportFilters.dateRange = this.dateRange;
            return reportFilters;
        },
        enumerable: true,
        configurable: true
    });
    return ReportFiltersComponent;
}());
export { ReportFiltersComponent };
